/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { paymentMethodContributionDataTypeSchema } from './PaymentMethodContributionDataTypeSchema'

export const paymentMethodContributionDataSchema = z.object({
	type: paymentMethodContributionDataTypeSchema,
	amount: z.number().nullable().optional(),
	paymentIntentId: z.string().nullable().optional(),
})

export type PaymentMethodContributionDataSchema = z.infer<typeof paymentMethodContributionDataSchema>
